export default __webpack_public_path__ + "static/media/auth-bg.44e050b0.jpg";